import { List, ListSubheader } from "@mui/material";
import { ActorDemandadoList } from "components/electronicFile/components/portadas/components/actorDemandadoList";
import { Actore } from "interfaces/solicitudFirma/solicitudFirmaInterface";

interface PartesDemandaPropsInterface{
    actores:Actore[] | null;
    demandados: Actore[] | null;
}

export const PartesDemanda = ({actores , demandados}:PartesDemandaPropsInterface) => {
  return (
    <>
      <List
        dense={true}
        subheader={<ListSubheader component="div">Actor(es)</ListSubheader>}
      >
        {actores &&
          actores.map((actor, key: number) => {
            return (
              <ActorDemandadoList nombre={actor.nombreCompleto} key={key} />
            );
          })}
      </List>
      <List
        dense={true}
        subheader={<ListSubheader component="div">Demandado(s)</ListSubheader>}
      >
        {demandados &&
          demandados.map((demandado, key: number) => {
            return (
              <ActorDemandadoList nombre={demandado.nombreCompleto} key={key} />
            );
          })}
      </List>
    </>
  );
};
